import React, { useEffect, useState } from "react";
import {
  Box, TextField, Typography, Button
} from "@mui/material";
import {
  addEmergencyContact,
  fetchEmergencyContactList,
  updateEmergencyContact,
} from "../../Adapters/ApiAdapter";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const HeaderContactNumber = () => {
  const [contact, setContact] = useState(null);
  const [formData, setFormData] = useState({
    domestic_number: "",
    international_number: "",
    emergency_number: "",
  });
  const [editingId] = useState(1); // Assumed fixed ID
  const [loading, setLoading] = useState(false);

  const getContact = async () => {
    try {
      const data = await fetchEmergencyContactList();
      setContact(data?.data || null);
    } catch (error) {
      console.error("Failed to load emergency contact", error);
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleEdit = () => {
    if (contact) {
      setFormData({
        domestic_number: contact.domestic_number || "",
        international_number: contact.international_number || "",
        emergency_number: contact.emergency_number || "",
      });
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   try {
  //     if (contact) {
  //       await updateEmergencyContact(editingId, formData);
  //     } else {
  //       await addEmergencyContact(formData);
  //     }
  //     setFormData({ domestic_number: "", international_number: "" });
  //     getContact();
  //   } catch (error) {
  //     console.error("Error submitting form", error);
  //   }
  //   setLoading(false);
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { domestic_number, international_number, emergency_number } = formData;

    // Prevent submission if both are empty
    if (
      !domestic_number.trim() &&
      !international_number.trim() &&
      !emergency_number.trim()
    ) {
      alert("Please enter at least one contact number.");
      return;
    }

    setLoading(true);
    try {
      // Prepare the final payload
      const updatedData = {
        domestic_number: domestic_number.trim() || contact?.domestic_number || "",
        international_number: international_number.trim() || contact?.international_number || "",
        emergency_number: emergency_number.trim() || contact?.emergency_number || "",
      };      

      if (contact) {
        await updateEmergencyContact(editingId, updatedData);
        toast.success("Contact Number updated successfully!");
      } else {
        await addEmergencyContact(updatedData);
        toast.success("Contact Number added successfully!");
      }

      setFormData({ domestic_number: "", international_number: "" });
      getContact();
    } catch (error) {
      console.error("Error submitting form", error);
    }
    setLoading(false);
  };


  useEffect(() => {
    getContact();
  }, []);

  return (
    <Box m="20px">
       <ToastContainer />
      <div className="p-6 bg-white rounded shadow">
        <h2 className="text-2xl font-bold mb-6">
          {contact ? "Edit" : "Add"} Emergency Contact
        </h2>
        <form onSubmit={handleSubmit} className="grid gap-5 max-w-xl">
          <div>
            <Typography variant="h4">
              Domestic Number
            </Typography>
            <TextField
              fullWidth
              margin="normal"
              name="domestic_number"
              value={formData.domestic_number}
              onChange={handleInputChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter domestic number"
            />
          </div>
          <div>
            <Typography variant="h4">
              International Number
            </Typography>
            <TextField
              fullWidth
              margin="normal"
              name="international_number"
              value={formData.international_number}
              onChange={handleInputChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter international number"
            />
          </div>
          <div>
            <Typography variant="h4">
              Emergency Number
            </Typography>
            <TextField
              fullWidth
              margin="normal"
              name="emergency_number"
              value={formData.emergency_number}
              onChange={handleInputChange}
              placeholder="Enter emergency number"
            />
          </div>
          <Button
            variant="contained"
            type="submit"
            disabled={loading}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-2 rounded disabled:opacity-50"
          >
            {loading ? "Saving..." : contact ? "Update" : "Add"}
          </Button>
        </form>

        {contact && (
          <div className="mt-8 bg-gray-50 p-4 rounded border">
            <h3 className="text-lg font-semibold mb-3">Current Contact Numbers</h3>
            <p className="mb-1">
              <strong>Domestic:</strong> {contact.domestic_number}
            </p>
            <p className="mb-3">
              <strong>International:</strong> {contact.international_number}
            </p>
            <p className="mb-1">
              <strong>Emergency:</strong> {contact.emergency_number || "022-66529979"}
            </p>
            <Button
              variant="contained"
              onClick={handleEdit}
              className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded"
            >
              Edit
            </Button>
          </div>
        )}
      </div>
    </Box>
  );
};

export default HeaderContactNumber;
